export enum LessonSlideStatus {
  NEXT = 'next',
  COMPLETED = 'completed',
  LOCKED = 'locked',
}
